import { Alert, ListItem, Typography } from "@mui/material";
import { propsToClassKey } from "@mui/styles";
import { useEffect, useState } from "react";
import { TextFieldComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import useAccomplishment from "../../hooks/useAccomplishments";
import { Accomplishment } from "../../models/Accomplishment";
import AlertComponent from "../AlertComponent";
import { AppDialog } from "../AppDialog";
import { AccomplishmentType } from "../../models/AccomplishmentType";

interface Props {
  accomplishment: Accomplishment | undefined;
  extraButton?: boolean;
  onClose: () => void;
  missingDocumentation?: boolean;
  action: "Approve" | "Reject";
  handleUpdateStatus: (instance: Accomplishment, status: "Approved" | "Pending" | "Rejected") => void;
}

export default function AccomplishmentStatusDialog(props: Props) {
  const [accomplishmentType, setAccomplishmentType] = useState<AccomplishmentType>();

  useEffect(() => {
    setAccomplishmentType(props.accomplishment!.type);
  }, []);

  if (!props.accomplishment) {
    return null;
  }
  return (
    <>
      {props.action === "Approve" ? (
        <AlertComponent
          title={`${accomplishmentType?.title}`}
          message={`You are going to approve this accomplishment for: ${accomplishmentType?.points} points`}
          confirmLabel={"Approve"}
          onConfirm={() => {
            props.handleUpdateStatus(props.accomplishment!, "Approved");
            props.onClose();
          }}
          cancelLabel={"Cancel"}
          onCancel={() => props.onClose()}
          renderContent={(register, errors, control) => (
            <>
              <Alert severity="warning" sx={{ marginTop: "1em" }}>
                <Typography style={{ fontWeight: "bold" }} gutterBottom children={"Approval conditions"} />
                <Typography gutterBottom variant={"body1"}>
                  {accomplishmentType?.approvalConditions}
                  {accomplishmentType?.additionalInfo?.map((i) => (
                    <>
                      <ListItem children={`- ${i}`} />
                    </>
                  ))}
                </Typography>
                <br />
                <Typography style={{ fontWeight: "bold" }}>{"Approval needed by"}</Typography>
                <Typography>{accomplishmentType?.approvalBy}</Typography>
                <br />
                <Typography style={{ fontWeight: "bold" }}>{"Approval accreditation data"}</Typography>
                <Typography>{accomplishmentType?.approvalAccreditationData}</Typography>
              </Alert>
            </>
          )}
          onClose={() => props.onClose()}
        />
      ) : (
        <AppDialog
          open={!!props.accomplishment}
          onClose={() => props.onClose()}
          title={`${accomplishmentType?.title}`}
          content={
            <>
              <Typography>{`Are you sure to reject this accomplishment?`}</Typography>
            </>
          }
          buttons={[
            {
              label: "Confirm",
              onClick: () => {
                props.handleUpdateStatus(props.accomplishment!, "Rejected");
                props.onClose();
              },
            },
          ]}
        />
      )}
    </>
  );
}
